// extracted by mini-css-extract-plugin
export default {"wrap":"tI-z","articleImagesWrap":"uI-z","articleImage":"vI-z","singleImage":"wI-z"};